import { JobStatus } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api';
import { audiogramHelpers } from '../screens/view/components/audiogram/helpers';

export function useFragmentQuery(fragmentId: string) {
  return useQuery({
    queryKey: useFragmentQuery.queryKey(fragmentId),
    queryFn: () => apiClient.fragments.fetch(fragmentId),
    retry: 15,
    refetchOnMount: true,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchInterval: (query) => {
      if (!query.state.data) {
        return false;
      }

      const data = query.state.data;

      const isMediaWaiting =
        data?.media?.status === 'WAITING' || data?.media?.status === 'IN_PROGRESS';

      const isAudiogramWaiting = !!audiogramHelpers.getInProgressVariants(data).length;

      const isAudiogramExportWaiting = Object.values(data?.audiogramExport?.platforms ?? {}).find(
        (data) => data?.status === JobStatus.QUEUED || data?.status === JobStatus.IN_PROGRESS,
      );

      const shouldRefetch = isMediaWaiting || isAudiogramWaiting || isAudiogramExportWaiting;

      return shouldRefetch ? 2000 : false;
    },
  });
}

useFragmentQuery.queryKey = (fragmentId: string) => ['fragment', fragmentId];
